export default {"src":"/_next/static/media/left_icon_arrow.07268837.svg","height":18,"width":10,"blurWidth":0,"blurHeight":0};